import React, { useEffect, useRef, useCallback } from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaTimes, FaInfoCircle } from 'react-icons/fa';
// Tailwind classes applied; external CSS removed

const Notification = ({ message, type = 'info', onClose, duration = 5000 }) => {
  const notificationRef = useRef(null);
  const timerRef = useRef(null);

  const handleClose = useCallback(() => {
    if (notificationRef.current) {
      notificationRef.current.classList.add('notification-exit');
      setTimeout(() => {
        onClose();
      }, 300); // Match this with the CSS transition duration
    }
  }, [onClose]);

  useEffect(() => {
    // Auto-dismiss after duration
    timerRef.current = setTimeout(() => {
      handleClose();
    }, duration);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [duration, handleClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="notification-icon" />;
      case 'error':
        return <FaExclamationTriangle className="notification-icon" />;
      case 'warning':
        return <FaExclamationTriangle className="notification-icon" />;
      default:
        return <FaInfoCircle className="notification-icon" />;
    }
  };

  // Handle different message types
  const renderMessage = () => {
    if (!message) return null;
    
    // If message is a string, render it directly
    if (typeof message === 'string') {
      return <p>{message}</p>;
    }
    
    // If message is an object with a text or message property
    if (typeof message === 'object') {
      const messageText = message.text || message.message || JSON.stringify(message);
      return <p>{messageText}</p>;
    }
    
    // Fallback for any other type
    return <p>{String(message)}</p>;
  };

  return (
    <div 
      ref={notificationRef}
      className={`notification notification-${type}`}
      role="alert"
      onClick={handleClose}
    >
      <div className="notification-content">
        <div className="notification-icon-container">
          {getIcon()}
        </div>
        <div className="notification-message">
          {renderMessage()}
        </div>
        <button 
          className="notification-close"
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          aria-label="Close notification"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default Notification;
